import type {SlotGameSubController} from "@gamzix/slot_core";

//@ts-ignore
class GameSlotGameSubController extends SlotGameSubController {
    constructor(game) {
        super(game);

        this.addCustomPhases(["showBigWin"], "SHOW_WIN", "showAllWins");
    }
}

export {GameSlotGameSubController};

Game.src.subController.GameSubController = GameSlotGameSubController;
